export * from '@whatsper/texterchat-common/constants';
import { WhatsApp } from '@whatsper/texterchat-common';
import packageJson from '../package.json';
export const VERSION = packageJson.version;
console.log("Inbox VERSION: ", VERSION);
export const MOBILE_WIDTH = 1026;
export const DESKTOP_WIDTH = 1600;
export var INPUT_BLOCK;
(function (INPUT_BLOCK) {
    INPUT_BLOCK["ACCEPT"] = "ACCEPT";
    INPUT_BLOCK["SESSION_OVER"] = "SESSION_OVER";
    INPUT_BLOCK["COMPOSE"] = "COMPOSE";
    INPUT_BLOCK["BLOCKED"] = "BLOCKED";
    INPUT_BLOCK["AUDIO_RECORD"] = "AUDIO_RECORD";
    INPUT_BLOCK["MESSENGER_PRIVATE_REPLY"] = "MESSENGER_PRIVATE_REPLY";
})(INPUT_BLOCK || (INPUT_BLOCK = {}));
// This is awful shitcode
/**
 * @deprecated This needs to be removed, not adde to new code
 */
export const ADDITIONAL_CHAT_STATUS = {
    PENDING_SELF: 6
};
export const STATISTICS_TABS = {
    TODAY: 0,
    LAST_WEEK: 1,
    LAST_MONTH: 2,
};
export const FILTER_TABS = {
    ALL_CHATS: 'ALL_CHATS',
    WHATSAPP: 'WHATSAPP',
    MESSENGER: 'MESSENGER',
    INSTAGRAM: 'INSTAGRAM'
};
export const FILTER_DEPARTMENTS = {
    ALL_DEPARTMENTS: 'ALL_DEPARTMENTS',
    NOT_ASSIGNED: 'NOT_ASSIGNED',
    OTHER: 'OTHER'
};
export const FILTER_AGENTS = {
    ALL_AGENTS: 'ALL_AGENTS',
    NOT_ASSIGNED: 'WITH_BOT',
    SPECIFIC_AGENT: 'SPECIFIC_AGENT',
    WITH_BOT: 'WITH_BOT'
};
export const SERVER_URL = process.env.REACT_APP_SERVER_URL || window.env.server_url || `${window.location.origin}/server`;
const [, , SERVER_HOST, , port] = SERVER_URL.match(/^http(s)?:\/\/([a-z0-9\.-]+)(:([0-9]+))?/i) || [];
const SERVER_PORT = port ? parseInt(port) : 80;
export { SERVER_HOST, SERVER_PORT };
export const API_PATH = {
    START_SESSION: '/auth/session',
    END_SESSION: '/auth/session/clear',
    HEARTBEAT: '/auth/heartbeat',
    AUTH: '/auth',
    FILES: '/files',
    BOTS: '/bots',
    BOTS_MANAGE: '/bots/manage',
    API_TOKENS: '/api_tokens',
    CHATS: '/chats',
    CRM: '/crm',
    WHATSAPP_STATS: '/whatsapp/stats',
    TEMPLATES: '/whatsapp/templates',
    USERS: '/users',
    ROLES: '/roles',
    DEPARTMENTS: '/departments',
    MESSAGES: '/messages',
    QUICK_REPLIES: '/quick-replies',
    NOTIFICATIONS: '/notifications',
    SETTINGS: '/settings',
    CHANNELS: '/channels',
    PERSONS: '/persons',
    EVENTS_STREAM: '/events/stream',
    BULK_REPORTS: '/templates/bulk/reports',
    STATS: '/stats',
    BUILD_ID: '/build-info.json',
    SCHEDULE: '/schedule',
    EXPORT: '/export',
    LABELS: '/labels',
    SCENARIOS: '/scenarios',
    SYSTEM: '/system',
};
export const USER_STATES = {
    UNKNOWN: 0,
    LOGGED_IN: 1,
    LOGGED_OUT: 2,
};
export var APP_STATE;
(function (APP_STATE) {
    APP_STATE[APP_STATE["INIT"] = 0] = "INIT";
    APP_STATE[APP_STATE["READY"] = 1] = "READY";
    APP_STATE[APP_STATE["ERROR"] = 2] = "ERROR";
})(APP_STATE || (APP_STATE = {}));
export var WIZARD_STEPS;
(function (WIZARD_STEPS) {
    WIZARD_STEPS[WIZARD_STEPS["ACCOUNT_STEP"] = 0] = "ACCOUNT_STEP";
    WIZARD_STEPS[WIZARD_STEPS["FIRST_STEP"] = 1] = "FIRST_STEP";
    WIZARD_STEPS[WIZARD_STEPS["SECOND_STEP"] = 2] = "SECOND_STEP";
    WIZARD_STEPS[WIZARD_STEPS["THIRD_STEP"] = 3] = "THIRD_STEP";
    WIZARD_STEPS[WIZARD_STEPS["FOURTH_STEP"] = 4] = "FOURTH_STEP";
    WIZARD_STEPS[WIZARD_STEPS["FIFTH_STEP"] = 5] = "FIFTH_STEP";
    WIZARD_STEPS[WIZARD_STEPS["SIXTH_STEP"] = 6] = "SIXTH_STEP";
})(WIZARD_STEPS || (WIZARD_STEPS = {}));
export const TIME_FORMAT = {
    TWELVE_HOURS: "TWELVE_HOURS",
    TWENTY_FOUR_HOURS: "TWENTY_FOUR_HOURS",
};
export var PHONE_FORMAT;
(function (PHONE_FORMAT) {
    PHONE_FORMAT["SMART"] = "SMART";
    PHONE_FORMAT["INTERNATIONAL"] = "INTERNATIONAL";
    PHONE_FORMAT["NATIONAL"] = "NATIONAL";
})(PHONE_FORMAT || (PHONE_FORMAT = {}));
export const CRM_STATUS = {
    ACTIVE: "ACTIVE",
    NOT_ACTIVE: "NOT_ACTIVE",
};
export var TEMPLATE_MESSAGE_STATUS;
(function (TEMPLATE_MESSAGE_STATUS) {
    TEMPLATE_MESSAGE_STATUS["REQUESTED"] = "REQUESTED";
    TEMPLATE_MESSAGE_STATUS["SUBMIT_FAILED"] = "SUBMIT_FAILED";
    TEMPLATE_MESSAGE_STATUS["PENDING"] = "PENDING";
    TEMPLATE_MESSAGE_STATUS["APPROVED"] = "APPROVED";
    TEMPLATE_MESSAGE_STATUS["REJECTED"] = "REJECTED";
    TEMPLATE_MESSAGE_STATUS["DELETION_PENDING"] = "DELETION_PENDING";
    TEMPLATE_MESSAGE_STATUS["DELETED"] = "DELETED";
    TEMPLATE_MESSAGE_STATUS["SUBMITTED"] = "SUBMITTED";
})(TEMPLATE_MESSAGE_STATUS || (TEMPLATE_MESSAGE_STATUS = {}));
export var TEMPLATE_USAGE;
(function (TEMPLATE_USAGE) {
    TEMPLATE_USAGE["INBOX"] = "inbox";
    TEMPLATE_USAGE["BULK"] = "bulk";
})(TEMPLATE_USAGE || (TEMPLATE_USAGE = {}));
export const TEMPLATE_RADIO_STATUSES = {
    TAKEN: 1,
    OTHER: 2
};
export var TEMPLATE_SORT;
(function (TEMPLATE_SORT) {
    TEMPLATE_SORT[TEMPLATE_SORT["NAME"] = 1] = "NAME";
    TEMPLATE_SORT[TEMPLATE_SORT["DATE_CREATED"] = 2] = "DATE_CREATED";
    TEMPLATE_SORT[TEMPLATE_SORT["LAST_USED"] = 3] = "LAST_USED";
})(TEMPLATE_SORT || (TEMPLATE_SORT = {}));
export const RICH_TEMPLATE_HEADER_TYPE = {
    TEXT: 'TEXT',
    IMAGE: 'IMAGE',
    DOCUMENT: 'DOCUMENT',
};
export const RICH_TEMPLATE_BUTTON_TYPE = {
    QUICK_REPLY: "QUICK_REPLY",
    CALL_TO_ACTION: "CALL_TO_ACTION"
};
export const CALL_TO_ACTION_TYPES = {
    URL: "URL",
    PHONE_NUMBER: "PHONE_NUMBER"
};
export const TEMPLATE_PARTS = {
    HEADER: "HEADER",
    BODY: "BODY",
    FOOTER: "FOOTER",
    BUTTONS: "BUTTONS",
};
export const DB_COLLECTIONS = {
    USERS: 'users',
    USERS_STATUS: 'users-status',
    SETTINGS: 'settings',
};
export const FEATURE = {
    CSV_REPORT: 'CSVReport',
    FULLTEXT_SEARCH: 'fulltext_search',
};
export const UNSUPPORTED_TEMPLATE_CATEGORIES = [
    WhatsApp.TemplateCategory.AUTHENTICATION,
];
export const SUPPORTED_TEMPLATE_CATEGORIES = Object.values(WhatsApp.TemplateCategory).filter((category) => !UNSUPPORTED_TEMPLATE_CATEGORIES.includes(category));
export var AGENT_TYPES;
(function (AGENT_TYPES) {
    AGENT_TYPES[AGENT_TYPES["ADMIN"] = 1] = "ADMIN";
    AGENT_TYPES[AGENT_TYPES["SIMPLE"] = 2] = "SIMPLE";
})(AGENT_TYPES || (AGENT_TYPES = {}));
export const LANGUAGES_TYPES = {
    HE: 'he',
    EN: 'en',
    AR: 'ar',
    RU: 'ru',
    IT: 'it',
    RO: 'ro',
};
export const TEMPLATE_FOOTER_MESSAGES = {
    [LANGUAGES_TYPES.HE]: "להסרה השב/י הסר",
    [LANGUAGES_TYPES.EN]: "To unsubscribe, please reply Unsubscribe",
};
export const RESOLVE_HOURS = {
    1: 1,
    3: 3,
    6: 6,
    12: 12,
    24: 24,
    36: 36,
    48: 48,
    72: 72,
    CUSTOM: 168,
};
export const CRM_IDS = {
    POWERLINK: "powerlink",
    GOOGLESHEET: "googlesheet",
    LEADIM: "leadim",
    SALESFORCE: "salesforce",
    NOVIDEA: "novidea",
    MONDAY: "monday",
    OPTIMA: "optima",
};
export const WEBSITE_LINK = "https://texterchat.com/";
export const HELP_CENTER_URLS = {
    he: 'https://help.texterchat.com/guides/welcome',
    en: 'https://help.texterchat.com/en/guides/welcome',
    ro: 'https://help.texterchat.com/en/guides/welcome',
};
export const HELP_CENTER_API_REFERENCE_URLS = {
    he: 'https://help.texterchat.com/he/api-reference/introduction',
    en: 'https://help.texterchat.com/api-reference/introduction',
    ro: 'https://help.texterchat.com/api-reference/introduction',
};
export const WHATSAPP_BUSINESS_MANAGER_URL = 'https://business.facebook.com/latest/whatsapp_manager/overview/';
export const MESSAGE_TEMPLATES_BUSINESS_URL = 'https://business.facebook.com/wa/manage/message-templates/';
export const AUTO_DELETE_PRICING_URL = 'https://drive.google.com/file/d/1J7mQgxR2JhpXQLem0fAv_L0d925-U7di/view';
export const TEXTERCHAT_HOMEPAGE_URL = 'https://texterchat.com/';
export const SEARCH_THROTTLE = 500;
export const SEARCH_MIN_QUERY = 2;
export const PROXY_FRONTEND_URL = process.env.REACT_APP_PROXY_FRONTEND_URL;
export const SLA_TIMEPICKER_FORMAT = "HH:mm";
export const DEFAULT_MSG_EXTRA_ACTIVITY_WINDOW_MS = 24 * 60 * 60 * 1000;
export const COMPOSE_SESSION_STATE_KEY = 'chatInput';
export const LABELS_COLORS = [
    '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', '#ba68c8'
];
export const SESSION_OVER_TEMPLATE_SEND_COST = 0.18;
/**
 * URL of the image used as example for template image header
 * if none provided instead.
 * @todo Make a better solution, this were added in urgency
 */
export const DEFAULT_EXAMPLE_TEMPLATE_IMG_URL = 'https://i.imgur.com/gtkrswP.jpeg';
export const LOCAL_STORAGE_KEYS = {
    FILTERS: {
        TEMPLATE_MANAGER_DEPARTMENTS_FILTER: 'templateManager_departmentsFilter',
        TEMPLATE_MANAGER_SORT_FILTER: 'templateManager_sortFilter',
        TEMPLATE_MANAGER_SEARCH_FILTER: 'templateManager_searchFilter',
        QUICK_REPLIES_DEPARTMENTS_FILTER: 'quickReplies_departmentsFilter',
        QUICK_REPLIES_MANAGE_DEPARTMENTS_FILTER: 'quickReplies_manageDepartmentsFilter',
        SINGLE_TEMPLATE_DEPARTMENTS_FILTER: 'singleTemplate_departmentsFilter',
        SINGLE_TEMPLATE_SORT_FILTER: 'singleTemplate_sortFilter',
        SINGLE_TEMPLATE_SEARCH_FILTER: 'singleTemplate_searchFilter',
        CHATS_LIST_AGENTS_FILTER: 'chatsList_agentFilter',
        CHATS_LIST_DEPARTMENTS_FILTER: 'chatsList_departmentsFilter',
    },
    SEEN_AI_QUICK_REPLIES: 'seenAiQuickReplies',
};
export const SESSION_STORAGE_KEYS = {
    SCENARIO_RUNS_FILTERS: 'scenarioRunsFilters',
};
export var AfterResolveChatAction;
(function (AfterResolveChatAction) {
    AfterResolveChatAction["NONE"] = "none";
    AfterResolveChatAction["SEND_CLOSING_MESSAGE"] = "sendClosingMessage";
    AfterResolveChatAction["RUN_BOT"] = "runBot";
})(AfterResolveChatAction || (AfterResolveChatAction = {}));
